import _ from 'lodash'
import { setPeriod } from 'src/redux/slices/learner/list'
import { convertFormatDateTime } from 'src/utils/lib'

export const handleChangePeriod = (selectedDates) => (dispatch) => {
  const startDate = convertFormatDateTime({
    value: _.get(selectedDates, 'startDate', ''),
    type: 'dateDb',
  })
  const finishDate = convertFormatDateTime({
    value: _.get(selectedDates, 'endDate', ''),
    type: 'dateDb',
  })
  dispatch(setPeriod({ startDate, finishDate }))
}

export const handleResetPeriod = () => (dispatch) => {
  dispatch(setPeriod({ startDate: '', finishDate: '' }))
}
